export default {
    state: {
        resultRegister: null,
        userData: null,
    },
    getters: {
        resultRegister: state => state.resultRegister,
        userData: state => state.userData,
    },
    mutations: {
        setResultRegister(state, resultRegister) {
			state.resultRegister = resultRegister
		},
        setUserData(state, userData) {
			state.userData = userData
		},
    },
    actions: {
        resetRegister({ commit }){
            commit('setResultRegister', null);
            commit('setUserData', null);
        }
    }
}